import React from "react";

import { Card, CardHeader, CardContent, Typography } from "@material-ui/core";
import ReleaseNotes from "app/ReleaseNotes";

const version = "2.16";

const ReleaseNotesEmail = () => {
  return (
    <div style={{ width: "800px", marginBottom: "20px" }}>
      <Card>
        <CardHeader
          title="Hakai Data Portal"
          subheader={`Version ${version}`}
          style={{
            backgroundColor: "#00AECE",
            height: "45px"
          }}
        />
        <CardContent>
          <div
            style={{
              border: "rgb(0, 174, 206) dashed 1px",
              marginBottom: "10px",
              padding: "10px"
            }}
          >
            <Typography variant="body1">
              Good morning EIMS Users! <br />
              <br />
              Version 2.16 aka{" "}
              <b>
                <a href="https://en.wikipedia.org/wiki/Nightjar">Nightjar</a>{" "}
                <a href="https://en.wiktionary.org/wiki/osmole">Osmole</a>
              </b>{" "}
              of the portal is now live. We have been concentrating hard on bug
              fixes and soaring to new hights with handy features. Of note, it
              is now possible do spatial searches on the data tools download
              page as well as view search outputs in table, map, and chart
              views.
              <br />
              Details of the release can be reviewed in this email or by
              visiting the{" "}
              <a href="https://portal.hakai.org/portal2/releases">
                Release Notes
              </a>
              . As always if you encounter any problems while using the portal
              we are happy to help. Please reach out to us at{" "}
              <a href="mailto::eims.support@hakai.org">
                eims.support@hakai.org
              </a>
              . <br />
              <br />
              Thank you,
              <br />
              The EIMS Team
            </Typography>
          </div>
          <ReleaseNotes showVersion={version} />
        </CardContent>
      </Card>
    </div>
  );
};

export default ReleaseNotesEmail;
